import script from "./MobileMasterInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileMasterInfo.vue?vue&type=script&setup=true&lang=ts"

import "./MobileMasterInfo.vue?vue&type=style&index=0&id=7de7f9f4&scoped=true&lang=css"

import exportComponent from "D:\\code\\frontEndCode\\collegeSubjectPage\\page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7de7f9f4"]])

export default __exports__